import { useEffect, useRef } from "react";
import type { Faction } from "../engine/types";

function rgbToHsv(r:number,g:number,b:number){r/=255;g/=255;b/=255;const max=Math.max(r,g,b),min=Math.min(r,g,b),d=max-min;let h=0;if(d){if(max===r)h=60*(((g-b)/d)%6);else if(max===g)h=60*((b-r)/d+2);else h=60*((r-g)/d+4);}if(h<0)h+=360;return[h,max?d/max:0,max] as const;}
function hsvToRgb(h:number,s:number,v:number){const c=v*s,x=c*(1-Math.abs((h/60)%2-1)),m=v-c;let r=0,g=0,b=0;if(h<60)[r,g,b]=[c,x,0];else if(h<120)[r,g,b]=[x,c,0];else if(h<180)[r,g,b]=[0,c,x];else if(h<240)[r,g,b]=[0,x,c];else if(h<300)[r,g,b]=[x,0,c];else[r,g,b]=[c,0,x];return[(r+m)*255,(g+m)*255,(b+m)*255];}

export function FactionPieceImage({asset,faction,className,label}:{asset:string;faction:Faction;className?:string;label?:string}){
  const canvasRef=useRef<HTMLCanvasElement>(null);
  useEffect(()=>{
    const canvas=canvasRef.current;if(!canvas)return;
    const image=new Image();
    image.onload=()=>{
      canvas.width=image.naturalWidth;canvas.height=image.naturalHeight;
      const ctx=canvas.getContext("2d",{willReadFrequently:true});if(!ctx)return;
      ctx.clearRect(0,0,canvas.width,canvas.height);ctx.drawImage(image,0,0);
      if(faction==="EFA")return;
      const pixels=ctx.getImageData(0,0,canvas.width,canvas.height);
      for(let i=0;i<pixels.data.length;i+=4){
        if(!pixels.data[i+3])continue;
        const[h,s,v]=rgbToHsv(pixels.data[i],pixels.data[i+1],pixels.data[i+2]);
        if(h<24||h>82||s<.16||v<.12)continue;
        const hue=faction==="REDCAT"?2:faction==="GREEN"?126:205,saturation=faction==="BLUE"?.1:Math.min(1,s*1.08),[r,g,b]=hsvToRgb(hue,saturation,v);
        pixels.data[i]=r;pixels.data[i+1]=g;pixels.data[i+2]=b;
      }
      ctx.putImageData(pixels,0,0);
    };
    image.src=import.meta.env.BASE_URL+"assets/"+asset;
  },[asset,faction]);
  return <canvas ref={canvasRef} className={className} role={label?"img":undefined} aria-label={label}/>;
}
